const DATA_TEST_IDS = {
  insuranceInsurance: 'company-details__insurance',
} as const;

export default DATA_TEST_IDS;
